import React from "react";
import { Heading, Flex, Spacer, Image } from "@chakra-ui/react";

const Header = () => {
    return (
        <Flex as="nav" align="center" justify="center" bg="teal.500" padding="1rem" boxShadow="0px 2px 4px rgba(0,0,0,0.2)">
            <Flex align="center" gap="2" >
                <Image src="/logo.png" boxSize="50px" objectFit="cover" />
                <Heading color="whitesmoke" size="md">Checker Arhitecturi</Heading>
            </Flex >
            <Spacer />
        </Flex>);
}
export default Header;